import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import notify from 'devextreme/ui/notify';
import Form from "devextreme-react/form";
import ArrayStore from "devextreme/data/array_store";
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import { ABECASUSER_LOGIN_TYPE } from "../../../../common/permissions";
import { alert } from 'devextreme/ui/dialog';
import NumberBox from 'devextreme-react/number-box';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';

import DataGrid, {
    Column,
    Editing,
    Lookup,
} from "devextreme-react/data-grid";
import Accordion from 'devextreme-react/accordion';
import axios from "axios";
import routes from "../../../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';
import { DateBox, TextArea } from "devextreme-react";
import FiscalYearComponent from "../../../../common/FRMFYP";
import TFYPManager from "../../../../common/FYPManager";

const searchpanel = [
    {
        ID: 1,
        Name: 'Search Filters'
    }
];
const orderByData = [
    { ID: 0, Text: "None" },
    { ID: 1, Text: "Ascending" },
    { ID: 2, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
    data: orderByData,
    key: "ID",
});

const prefixData = [
    { ID: 0, Text: "And" },
    { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
    data: prefixData,
    key: "ID",
});
const groupData = [
    { ID: 0, Text: "No" },
    { ID: 1, Text: "Begin" },
    { ID: 2, Text: "End" },
];
const operationData = [
    { ID: 0, Text: "StartsWith" },
    { ID: 1, Text: "EndsWith" },
    { ID: 2, Text: "Contains" },
    { ID: 3, Text: "Equal" },
    { ID: 4, Text: "NotEqual" },
    { ID: 5, Text: "Greater" },
    { ID: 6, Text: "GreaterEqual" },
    { ID: 7, Text: "Less" },
    { ID: 8, Text: "LessEqual" },
    { ID: 9, Text: "Between" },
    { ID: 10, Text: "Includes" },
];

const groupDataSource = new ArrayStore({
    data: groupData,
    key: "ID",
});
const operationDataSource = new ArrayStore({
    data: operationData,
    key: "ID",
});
let accessToken = "";
let ignoreListSelectionChange = false;
const dataGrid = React.createRef();
const list = React.createRef();
class GenerateInvoices extends React.Component {
    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        this.LoadWMInvoiceHeaderFields = this.LoadWMInvoiceHeaderFields.bind(this);
        this.StartButtonClicked = this.StartButtonClicked.bind(this);
        this.previewButtonClicked = this.previewButtonClicked.bind(this);
        this.resetButtonClicked = this.resetButtonClicked.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
        this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
        this.dataFieldRender = this.dataFieldRender.bind(this);
        this.handleCloseFYPPopUpCallback = this.handleCloseFYPPopUpCallback.bind(this);
        this.DateToUseChange = this.DateToUseChange.bind(this);
        this.SettingsValuesChanged = this.SettingsValuesChanged.bind(this);
        this.LoadFrequencyCodes = this.LoadFrequencyCodes.bind(this);
        this.parentCallBackOkButton = this.parentCallBackOkButton.bind(this);
        this.parentCallBackCancelButton = this.parentCallBackCancelButton.bind(this);
        this.ProcessGeneratingInvoice = this.ProcessGeneratingInvoice.bind(this);
        // this.Fiscal = this.Fiscal.bind(this);
        this.FYPManager = new TFYPManager(accessToken);

        this.state = this.getInitialState(props);
        this.toolbarItems = [{
            widget: 'dxButton',
            location: 'right',
            options: {
                icon: 'menu',
                onClick: () => this.setState({ opened: !this.state.opened }),
            },
        }];
        this.LoadWMInvoiceHeaderFields();
        this.LoadFrequencyCodes();
    }
    getInitialState(props) {
        return {
            animationDuration: 300,
            selectedItems: [],
            isPreviewGridPopupVisible: false,
            isPrintPreviewPopupVisible: false,
            isFiscalPopupVisible: false,
            loadIndicatorVisible: false,
            connection: null,
            ABErros: [],
            previewData: [],
            opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
            generatedFileName: "",
            report: {
                key: "",
                name: "",
                fullName: "",
                ignoreCompany: false,
                parameterList: [],
                queryParameters: [],
                whereInfoList: [],
                filterWhereInfoList: [
                ],
            },
            settings: {
                datetouse: "C",
                invoicedate: new Date(),
                invoicedateDisable: true,
                calculatedays: 0,
                calculatedaysDisable: false,
                frequency: "",
                description: "",
                reference: "",
                genzerodollarinvcs: "Y",
                invoicetitle: "Invoice",
                comment: "",
                fiscalyear: 0,
                fiscalperiod: 0,
            },
            fiscalYP: {
                Success: "",
                Message: "",
                FieldCaption: "",
                lblTextHeading: "",
                TransDate: "",
                MaxPriorPeriods: "",
                MaxPeriodsInPriorYear: "",
                NumPrevYearPer: "",
                MinPeriod: "",
                MinYear: "",
                MaxPeriod: "",
                MaxYear: "",
                FiscalPeriod: "",
                FiscalYear: "",
                IsPostPeriod: "",
                isFurtherCheckRequired: true,
            },
            datetouseArr: [{ name: "Calculated from Current Date", value: "C" }, { name: "Specific Date", value: "S" }],
            frequencyArr: [],
            genzerodollarinvcsArr: [{ name: "Yes (Default)", value: "Y" }, { name: "No", value: "N" }],
            formData: {},
            formItems: [],
        };
    }

    async Fiscal() {
        const response = await this.FYPManager.checkFiscalYearPeriod('WM', this.state.settings.invoicedate);
        if (response.Success == true) {
            this.setState(prevState => ({
                fiscalYP: {
                    ...prevState.fiscalYP,
                    Message: response.Message,
                    FieldCaption: response.FieldCaption,
                    lblTextHeading: response.lblTextHeading,
                    TransDate: response.TransDate,
                    MaxPriorPeriods: response.MaxPriorPeriods,
                    MaxPeriodsInPriorYear: response.MaxPeriodsInPriorYear,
                    NumPrevYearPer: response.NumPrevYearPer,
                    MinPeriod: response.MinPeriod,
                    MinYear: response.MinYear,
                    MaxPeriod: response.MaxPeriod,
                    MaxYear: response.MaxYear,
                    FiscalPeriod: response.FiscalPeriod,
                    FiscalYear: response.FiscalYear,
                    IsPostPeriod: response.IsPostPeriod,
                },
                isFiscalPopupVisible: response.isFiscalYearPopUpNeeded
            }));
        } else {
            this.setState(prevState => ({
                ...prevState.settings,
                isFiscalPopupVisible: false
            }));
            console.log("Not Allowed");
        }
    }
    parentCallBackOkButton = (fp, fy) => {
        this.setState(
            (prevState) => ({
                ...prevState,
                fiscalYP: {
                    ...prevState.fiscalYP,
                    isFurtherCheckRequired: false,
                },
                settings: {
                    ...prevState.settings,
                    fiscalyear: fp,
                    fiscalperiod: fy,
                },
                isFiscalPopupVisible: false,
            }),
            () => {
                this.ProcessGeneratingInvoice();
            }
        );
    };

    parentCallBackCancelButton() {
        this.setState(prevState => ({
            ...prevState,
            fiscalYP: {
                ...prevState.fiscalYP,
                isFurtherCheckRequired: true,
            },
            settings: {
                ...prevState.settings,
                fiscalyear: 0,
                fiscalperiod: 0,
            },
            isFiscalPopupVisible: false,
        }));
    }
    async StartButtonClicked(e) {
        try {
            if (e != null && e != undefined)
                e.event.stopPropagation();
            if (this.state.fiscalYP.isFurtherCheckRequired) {
                const response = await this.FYPManager.checkFiscalYearPeriod('WM', this.state.settings.invoicedate);
                if (response.Success == true) {
                    if (response.isFiscalYearPopUpNeeded) {
                        this.setState(prevState => ({
                            ...prevState,
                            fiscalYP: {
                                ...prevState.fiscalYP,
                                Message: response.Message,
                                FieldCaption: response.FieldCaption,
                                lblTextHeading: response.lblTextHeading,
                                TransDate: response.TransDate,
                                MaxPriorPeriods: response.MaxPriorPeriods,
                                MaxPeriodsInPriorYear: response.MaxPeriodsInPriorYear,
                                NumPrevYearPer: response.NumPrevYearPer,
                                MinPeriod: response.MinPeriod,
                                MinYear: response.MinYear,
                                MaxPeriod: response.MaxPeriod,
                                MaxYear: response.MaxYear,
                                FiscalPeriod: response.FiscalPeriod,
                                FiscalYear: response.FiscalYear,
                                IsPostPeriod: response.IsPostPeriod,
                            },
                            isFiscalPopupVisible: response.isFiscalYearPopUpNeeded
                        }));
                        return;
                    }
                    if (response.isFiscalYearPopUpNeeded == false && response.Message) {
                        alert(response.Message, "Warning");
                        return
                    }
                }
            }
            this.ProcessGeneratingInvoice();
        }
        catch (error) {
            notify({
                message: 'Generate Invoices Process Failed!',
                width: 450,
            }, 'error', 2000);
            console.error('Error, Generate Invoices Process Failed!', error);
        }
        finally {
            this.setState({
                loadIndicatorVisible: false,
            });
        }
    }
    async ProcessGeneratingInvoice() {
        try {
            var obj = { ...this.state.settings };
            if (obj.frequency == "") {
                alert("You must select Frequency Code before starting.", "Warning");
                return;
            }
            this.setState({
                loadIndicatorVisible: true,
            });
            if (obj.fiscalyear == 0 && obj.fiscalperiod == 0) {
                let [p, y] = await this.FYPManager.getCurrentFiscalPeriodYear();
                obj.fiscalyear = y;
                obj.fiscalperiod = p;
                this.setState(prevState => ({
                    ...prevState,
                    settings: {
                        ...prevState.settings,
                        fiscalyear: y,
                        fiscalperiod: p,
                    },
                }));
            }

            let request = {
                filterWhereInfoList: this.state.report.filterWhereInfoList,
                ...obj
            };
            axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.WMGenerateInvoices.ProcessGenerateInvoices}`,
                JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            ).then((response) => {
                this.setState({
                    loadIndicatorVisible: false,
                });
                if (response.data.success) {
                    alert('Records Processed! ' + response.data.message, "Success");
                    this.setState(this.getInitialState(this.props), () => {
                        this.LoadWMInvoiceHeaderFields();
                        this.LoadFrequencyCodes();
                    });
                }
                else {
                    alert('Couldnt Process! : ' + response.data.message, "Error");
                }
            }).catch((err) => {
                this.setState({
                    loadIndicatorVisible: false
                });
                notify({
                    message: 'Couldnt Load Data!!',
                    width: 450,
                }, 'error', 2000);
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
        }
        catch (error) {
            notify({
                message: 'Generate Invoices Process Failed!',
                width: 450,
            }, 'error', 2000);
            console.error('Error, Generate Invoices Process Failed!', error);
        }
        finally {
            this.setState({
                loadIndicatorVisible: false,
            });
        }
    }
    SettingsValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            settings: {
                ...prvState.settings,
                [ctrlName]: value,
            }
        }));
    }
    DateToUseChange(e) {
        if (e && e.value == 'S') {
            this.setState(prevState => ({
                settings: {
                    ...prevState.settings,
                    invoicedateDisable: false,
                    calculatedays: 0,
                    calculatedaysDisable: true,
                    datetouse: e.value
                },
            }));
        }
        else {
            this.setState(prevState => ({
                settings: {
                    ...prevState.settings,
                    invoicedateDisable: true,
                    calculatedays: 0,
                    calculatedaysDisable: false,
                    invoicedate: new Date(),
                    datetouse: e.value
                },
            }));
        }
    }
    LoadFrequencyCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.WMGenerateInvoices.GetFrequencyLookup}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        frequencyArr: response.data.resultdata
                    });
                }
                else {
                    notify({
                        message: response.data.message,
                        width: 100,
                    }, 'error', 2000);
                }
            })
            .catch((err) => {
                console.log(err, "Error in loading frequency codes");
                notify({
                    message: "Error in loading frequency codes",
                    width: 100,
                }, 'error', 2000);
            });
    }
    resetButtonClicked(e) {
        e.event.stopPropagation();
        this.setState(this.getInitialState(this.props), () => {
            this.LoadWMInvoiceHeaderFields();
            this.LoadFrequencyCodes();
        });
    }
    async previewButtonClicked(e) {
        if (e != null && e != undefined)
            e.event.stopPropagation();
        this.setState({
            loadIndicatorVisible: true
        });
        const data = await this.PreviewData();
        this.setState({
            previewData: data.resultdata,
            isPreviewGridPopupVisible: true,
            loadIndicatorVisible: false
        });
    }
    selectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState({
            selectedItems: newItems
        });
    }
    dataFieldRender(e) {
        var dataSource = dataGrid.current.instance().getDataSource();
        if (dataSource != null && dataSource._items != null) {
            var found = dataSource._items.find(i => i.origin == e.itemData.origin);
            if (found != null && found != undefined) {
                if (!e.component.isItemSelected(e.itemIndex)) {
                    ignoreListSelectionChange = true;
                    e.component.selectItem(e.itemIndex);
                    ignoreListSelectionChange = false;
                }
            }
        }
    }
    dataFieldSelectionChanged(e) {
        if (!ignoreListSelectionChange) {
            if (e.addedItems != null && e.addedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .insert(e.addedItems[0])
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }

            if (e.removedItems != null && e.removedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .remove(e.removedItems[0].displayLabel)
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }
        }
    }

    handleCloseFYPPopUpCallback() {
        this.setState({
            isFiscalPopupVisible: false,
        });
    };
    LoadWMInvoiceHeaderFields() {
        var that = this;
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${'WMGENERATEINVOICESWMD0021'}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((res) => {

                for (
                    var i = 0;
                    res.data.filterWhereInfoList != null &&
                    i < res.data.filterWhereInfoList.length;
                    i++
                ) {
                    switch (res.data.filterWhereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                                }

                                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                for (
                    var i = 0;
                    res.data.whereInfoList != null &&
                    i < res.data.whereInfoList.length;
                    i++
                ) {
                    switch (res.data.whereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                                }

                                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                that.setState({
                    report: res.data,
                });

                var formData = new Object();

                var formItems = [];

                for (
                    var i = 0;
                    that.state.report.parameterList != null &&
                    i < that.state.report.parameterList.length;
                    i++
                ) {
                    formData[that.state.report.parameterList[i].name] =
                        that.state.report.parameterList[i].value;
                    var formItem = new Object();
                    formItem.dataField = that.state.report.parameterList[i].name;
                    formItem.label = new Object();
                    formItem.label.text = that.state.report.parameterList[i].label;
                    switch (that.state.report.parameterList[i].parameterType) {
                        case 1: // Integer
                        case 2: // Decimal
                            formItem.editorType = "dxNumberBox";
                            break;
                        case 3: // Boolean
                            formItem.editorType = "dxCheckBox";
                            break;
                        case 4: // DateTime
                            formItem.editorType = "dxDateBox";
                            break;
                        case 5: // Flag
                            formItem.editorType = "dxSelectBox";
                            formItem.editorOptions = new Object();
                            formItem.editorOptions.items = [];

                            for (
                                var j = 0;
                                j < that.state.report.parameterList[i].items.length;
                                j++
                            ) {
                                var selectBoxItem = new Object();
                                selectBoxItem.Value =
                                    that.state.report.parameterList[i].items[j].value;
                                selectBoxItem.Text =
                                    that.state.report.parameterList[i].items[j].text;
                                formItem.editorOptions.items.push(selectBoxItem);
                            }

                            formItem.editorOptions.displayExpr = "Text";
                            formItem.editorOptions.valueExpr = "Value";
                            break;
                        default:
                            formItem.editorType = "dxTextBox";
                    }
                    formItems.push(formItem);
                }
                that.setState({
                    formData: formData,
                });
                that.setState({
                    formItems: formItems,
                });
                var dataFilterDataSource = new ArrayStore({
                    data: that.state.report.filterWhereInfoList,
                    key: "displayLabel",
                });
                dataGrid.current.instance().option("dataSource", dataFilterDataSource);
                ignoreListSelectionChange = true;
                for (var i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
                    for (var j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
                        if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
                            if (!list.current.instance().isItemSelected(i)) {
                                list.current.instance().selectItem(i);
                            }
                            break;
                        }
                    }
                }
                ignoreListSelectionChange = false;
            })
            .catch((err) => {
                console.log(err, "Error getting data");
            });
    }
    render() {
        return (
            <>
                <div id="wm-generate-invoices">
                    {/*<Button className="accordianButton" onClick={(e) => this.Fiscal(e)} text="Fiscal Testing" type="default" />*/}
                    <div className="row ">
                        <div className="col-md-12 main-page">
                            <div id="accordion" >
                                <Accordion
                                    dataSource={searchpanel}
                                    collapsible={true}
                                    multiple={false}
                                    animationDuration={this.state.animationDuration}
                                    selectedItems={this.state.selectedItems}
                                    onSelectionChanged={this.selectionChanged}
                                    itemTitleRender={() => (
                                        <Toolbar className="accordian-toolbar">
                                            <Item location="before">
                                                <div className="title">
                                                    <h6 style={{ color: window._env_.Color2 }}>
                                                        Generate Invoices
                                                    </h6>
                                                </div>
                                            </Item>
                                            <Item location="after">
                                                <Button className="accordianButton" onClick={(e) => this.StartButtonClicked(e, false)} text="Start" type="default" />
                                            </Item>
                                            <Item location="after">
                                                <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                                            </Item>
                                        </Toolbar>
                                    )}
                                    itemRender={(itemProps) => (
                                        <>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <SelectBox
                                                        dataSource={this.state.datetouseArr}
                                                        value={this.state.settings.datetouse}
                                                        valueExpr='value'
                                                        displayExpr='name'
                                                        className="light-ui-textbox"
                                                        label="Date to Use"
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        onValueChanged={(e) => this.DateToUseChange(e)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <DateBox
                                                        className="light-ui-textbox"
                                                        label="Invoice Date"
                                                        value={this.state.settings.invoicedate}
                                                        displayFormat="MM/dd/yyyy"
                                                        type="date"
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        disabled={this.state.settings.invoicedateDisable}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("invoicedate", e.value)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <NumberBox
                                                        className="light-ui-textbox"
                                                        format="#,###"
                                                        label="Calc (+/- days)"
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        value={this.state.settings.calculatedays}
                                                        disabled={this.state.settings.calculatedaysDisable}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("calculatedays", e.value)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <SelectBox
                                                        dataSource={this.state.frequencyArr}
                                                        value={this.state.settings.frequency}
                                                        valueExpr='name'
                                                        displayExpr='name'
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        className="light-ui-textbox"
                                                        label="Frequency"
                                                        onValueChanged={(e) => this.SettingsValuesChanged("frequency", e.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row py-2">
                                                <div className="col-md-3">
                                                    <TextBox
                                                        className="light-ui-textbox"
                                                        label="Description"
                                                        maxLength={30}
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        value={this.state.settings.description}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("description", e.value)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <TextBox
                                                        className="light-ui-textbox"
                                                        label="Reference"
                                                        maxLength={30}
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        value={this.state.settings.reference}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("reference", e.value)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <SelectBox
                                                        dataSource={this.state.genzerodollarinvcsArr}
                                                        value={this.state.settings.genzerodollarinvcs}
                                                        valueExpr='value'
                                                        displayExpr='name'
                                                        className="light-ui-textbox"
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        label="Gen $0 Incvs"
                                                        onValueChanged={(e) => this.SettingsValuesChanged("genzerodollarinvcs", e.value)}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <TextBox
                                                        className="light-ui-textbox"
                                                        label="Invoice Title"
                                                        maxLength={40}
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        value={this.state.settings.invoicetitle}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("invoicetitle", e.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <TextArea
                                                        className="light-ui-textbox"
                                                        label="Comment"
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        value={this.state.settings.comment}
                                                        onValueChanged={(e) => this.SettingsValuesChanged("comment", e.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    id="accordion-container" className="accordion-height"
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ minWidth: "900px" }}>
                        <Form
                            id="form"
                            labelMode="static"
                            labelLocation="left"
                            formData={this.state.formData}
                            items={this.state.formItems}
                            colCount={5}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
                        <Toolbar items={this.toolbarItems} />
                    </div>
                </div>
                <div className="row bg-white">
                    <div>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
                            visible={this.state.loadIndicatorVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <Drawer
                            opened={this.state.opened}
                            openedStateMode={'shrink'}
                            position={'left'}
                            revealMode={'slide'}
                            render={() =>
                                <List
                                    ref={list}
                                    dataSource={this.state.report.whereInfoList}
                                    pageLoadMode="scrollBottom"
                                    style={{ backgroundColor: '#F6F7FB' }}
                                    displayExpr="displayLabel"
                                    searchEnabled={true}
                                    searchExpr="displayLabel"
                                    showSelectionControls={true}
                                    selectionMode="multiple"
                                    onSelectionChanged={this.dataFieldSelectionChanged}
                                    onItemRendered={this.dataFieldRender}
                                ></List>}
                            closeOnOutsideClick={false}
                            className={this.state.selectedItems.length>0? "ReportFilterPanelHeightAccordionOpen" : "GridHeightTabPanel-with-toolbar"}>
                            <div>
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                    id="gridContainer"
                                    ref={dataGrid}
                                    showBorders={true}
                                    className={this.state.selectedItems.length>0?(this.state.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed"}
                                    rowAlternationEnabled={true}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    onEditorPreparing={this.editorPreparing}
                                    onCellClick={this.CellClik}
                                >
                                    <Editing
                                        mode="cell"
                                        newRowPosition="last"
                                        refreshMode="repaint"
                                        allowUpdating={true}
                                        useIcons={true}
                                    />
                                    <Column
                                        dataField="displayLabel"
                                        caption="Display Label"
                                        allowEditing={false}
                                    />
                                    <Column dataField="orderBy" caption="Order By">
                                        <Lookup
                                            dataSource={orderByDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="prefix" caption="Prefix">
                                        <Lookup
                                            dataSource={prefixDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="group" caption="Group">
                                        <Lookup
                                            dataSource={groupDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="operation" caption="Operation">
                                        <Lookup
                                            dataSource={operationDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="from" caption="From" />
                                    <Column dataField="to" caption="To" />
                                    <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                                </DataGrid>
                            </div>
                        </Drawer>
                    </div>
                </div>
                {
                    (this.state.isFiscalPopupVisible && !this.state.settings.Message) &&
                    <Popup visible={this.state.isFiscalPopupVisible}
                        onHiding={this.handleCloseFYPPopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title={"Fiscal period/year selection"}
                        container=".dx-viewport"
                        closeOnOutsideClick={false}
                        width="40vw"
                        height="50vh"
                    >
                        <ScrollView width="100%" height="100%">
                            <FiscalYearComponent
                                Message={this.state.fiscalYP.Message}
                                FieldCaption={this.state.fiscalYP.FieldCaption}
                                lblTextHeading={this.state.fiscalYP.lblTextHeading}
                                TransDate={this.state.fiscalYP.TransDate}
                                MaxPriorPeriods={this.state.fiscalYP.MaxPriorPeriods}
                                MaxPeriodsInPriorYear={this.state.fiscalYP.MaxPeriodsInPriorYear}
                                NumPrevYearPer={this.state.fiscalYP.NumPrevYearPer}
                                MinPeriod={this.state.fiscalYP.MinPeriod}
                                MinYear={this.state.fiscalYP.MinYear}
                                MaxPeriod={this.state.fiscalYP.MaxPeriod}
                                MaxYear={this.state.fiscalYP.MaxYear}
                                FiscalPeriod={this.state.fiscalYP.FiscalPeriod}
                                FiscalYear={this.state.fiscalYP.FiscalYear}
                                IsPostPeriod={this.state.fiscalYP.IsPostPeriod}
                                parentCallBackOkButton={this.parentCallBackOkButton}
                                parentCallBackCancelButton={this.parentCallBackCancelButton}
                            />
                        </ScrollView>
                    </Popup>
                }
            </>
        );
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateInvoices);